import { useCallback } from 'react';

import { createAiOriginalImage } from '../services';

import { useHomeownerAppContext } from './useHomeownerAppContext';

export const useUploadOriginalImage = () => {
  const { trackingData } = useHomeownerAppContext();

  return useCallback(
    async (variables: {
      image: File;
      email?: string;
      spaceType?: string;
      marketingConsent?: string;
      jobClientIdentifier?: string | null;
    }) => {
      const result = await createAiOriginalImage(
        variables.image,
        {
          email: variables.email,
          spaceType: variables.spaceType,
          marketingConsent: variables.marketingConsent,
          jobClientIdentifier: variables.jobClientIdentifier,
        },
        trackingData,
        true,
      );

      return result;
    },
    [trackingData],
  );
};
